/* eslint-disable react-hooks/exhaustive-deps */
import { Table, Input, Button, Card } from "antd";
import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { formatCurrency } from "../../utils/formatters";
import { apiClient } from "../Api/AllApi";
import "../Styles/ListPages.css";

const TableOrder = () => {
  const [SearchText, setSearchText] = useState("");
  const [dataSource, setDataSource] = useState([]);
  const { t } = useTranslation();
  const navigate = useNavigate();

  useEffect(() => {
    GetApiOrder();
  }, []);

  const GetApiOrder = async () => {
    try {
      const res = await apiClient.get("/orders");

      const formattedData = res.data.map((item) => ({
        id: item.id,
        total_price: item.total_price,
        amount_paid: item.amount_paid,
        customer: item.customer ? item.customer.name : t("noCustomer"),
        Type: item.customer ? item.customer.type : t("unknown"),
        Number: item.customer ? item.customer.phone_number : t("noNumber"),
        created_at: item.created_at, // Add created_at field
      }));

      setDataSource(formattedData);
    } catch (error) {
      console.error("Failed to fetch orders:", error);
    }
  };

  // Apply global search to filtered data
  const filteredData = dataSource.filter((item, index) => {
    const search = SearchText.toLowerCase();
    return (
      item.customer.toLowerCase().includes(search) ||
      item.Number.toLowerCase().includes(search) ||
      item.Type.toLowerCase().includes(search) ||
      String(item.total_price).includes(search) ||
      String(item.amount_paid).includes(search) ||
      String(index + 1).includes(search)
    );
  });

  const columns = [
    {
      title: t("id"),
      key: "index",
      render: (text, record, index) => index + 1,
    },
    {
      title: <span style={{ fontWeight: "bold" }}>{t("customer")}</span>,
      dataIndex: "customer",
      key: "customer",
      render: (text, record) => (
        <Link to={`/TableOrder/InfoOrder/${record.id}`}>{text}</Link>
      ),
    },
    {
      title: <span style={{ fontWeight: "bold" }}>{t("number")}</span>,
      dataIndex: "Number",
      key: "Number",
      render: (text, record) => (
        <Link to={`/TableOrder/InfoOrder/${record.id}`}>{text}</Link>
      ),
    },
    {
      title: <span style={{ fontWeight: "bold" }}>{t("type")}</span>,
      dataIndex: "Type",
      key: "Type",
      render: (text, record) => {
        let customerType = t("unknown");
        if (record.Type === "individual") customerType = t("individual");
        else if (record.Type === "company") customerType = t("company");
        else if (record.Type === "organization")
          customerType = t("organization");

        return (
          <Link to={`/TableOrder/InfoOrder/${record.id}`}>{customerType}</Link>
        );
      },
    }, {
      title: <span style={{ fontWeight: "bold" }}>{t("amountPaid")}</span>,
      dataIndex: "amount_paid",
      key: "amount_paid",
      render: (text, record) => (
        <Link to={`/TableOrder/InfoOrder/${record.id}`}>
          {formatCurrency(text, t("IQD"))}
        </Link>
      ),
    },
    {
      title: <span style={{ fontWeight: "bold" }}>{t("totalPrice")}</span>,
      dataIndex: "total_price",
      key: "total_price",
      render: (text, record) => (
        <Link to={`/TableOrder/InfoOrder/${record.id}`}>
          {formatCurrency(text, t("IQD"))}
        </Link>
      ),
    },
    {
      title: <span style={{ fontWeight: "bold" }}>{t("createdAt")}</span>,
      dataIndex: "created_at",
      key: "created_at",
      render: (text) => text ? new Date(text).toLocaleDateString() : "-",
    },
    {
      title: 'Actions',
      key: 'actions',
      render: (text, record) => (
        <>
          <Button
            type="primary"
            onClick={() => navigate(`/edit-order/${record.id}`)}
            style={{ marginLeft: 8 }}
          >
            Edit
          </Button>
        </>
      ),
    },
  ];

  return (
    <div className="list-page">
      <Card
        title={
          <span style={{ fontWeight: "600", fontSize: "1.125rem" }}>
            {t("orders")}
          </span>
        }
        bordered={false}
      >
        <Input.Search
          placeholder={t("searchPlaceholder")}
          style={{
            marginBottom: 16,
            maxWidth: 400,
          }}
          onSearch={(value) => setSearchText(value)}
          onChange={(e) => setSearchText(e.target.value)}
        />
        <div style={{ overflowX: "auto" }}>
          <Table
            dataSource={filteredData.map((item) => ({ ...item, key: item.id }))}
            columns={columns}
            pagination={{ pageSize: 50 }}
            scroll={{ x: "max-content" }}
            style={{ overflowX: "auto", maxWidth: "100%" }}
            locale={{ emptyText: t("noDataFound") }}
          />
        </div>
      </Card>
    </div>
  );
};

export default TableOrder;
